import { jsx as _jsx } from "react/jsx-runtime";
const ColorButton = ({ color, selected, onClick, }) => (_jsx("button", { onClick: onClick, className: `w-8 h-8 rounded-full border-2 ${selected ? "border-blue-600" : "border-transparent"} transition-all hover:scale-110`, style: {
        backgroundColor: color.toLowerCase(),
        border: color.toLowerCase() === "white" ? "1px solid #e5e7eb" : undefined,
    }, "aria-label": color }));
export default ColorButton;
